import Image from "next/image";
import ImagesSoftware from "@/assets/ImagesSoftware.png";
import CameraQuadro from "@/assets/CameraQuadra.png";
import ApertandoBotao from "@/assets/ApertandoBotao.png";
import AcessoAGravacoes from "@/assets/AcessoAGravacoes.png";

export default function HowItWorksSportsScreen() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-[80%] h-screen items-start justify-start p-0 mb-40">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full h-full p-4">
          <div className="bg-gray-200 shadow-lg rounded-lg flex flex-col items-center justify-center p-8 transform transition-transform duration-300 hover:scale-95">
            <Image
              src={ImagesSoftware.src}
              width={400}
              height={400}
              alt="Rounded Image"
            />
            <h2 className="text-2xl font-bold mb-2">Aquisição do Sistema</h2>
            <p className="text-base text-gray-700">
              A quadra contrata o serviço por meio de uma assinatura mensal.
            </p>
          </div>
          <div className="bg-gray-200 shadow-lg rounded-lg flex flex-col items-center justify-center p-8 transform transition-transform duration-300 hover:scale-95">
            <Image
              src={CameraQuadro.src}
              width={400}
              height={400}
              alt="Rounded Image"
            />
            <h2 className="text-2xl font-bold mb-2">
              Instalação dos Equipamentos
            </h2>
            <p className="text-base text-gray-700">
              São instaladas câmeras e botões próximos à quadra para capturar os
              lances.
            </p>
          </div>
          <div className="bg-gray-200 shadow-lg rounded-lg flex flex-col items-center justify-center p-5 transform transition-transform duration-300 hover:scale-95">
            <Image
              src={ApertandoBotao.src}
              width={400}
              height={400}
              alt="Rounded Image"
            />
            <h2 className="text-2xl font-bold mb-5">Funcionamento</h2>
            <p className="text-base text-gray-700">
              Sempre que um jogador quiser revisar um lance, ele pressiona um
              botão ao lado da quadra.
            </p>
          </div>
          <div className="bg-gray-200 shadow-lg rounded-lg flex flex-col items-center justify-center p-8 transform transition-transform duration-300 hover:scale-95">
            <Image
              src={AcessoAGravacoes.src}
              width={400}
              height={400}
              alt="Rounded Image"
            />
            <h2 className="text-2xl font-bold mb-2">Acesso às Gravações</h2>
            <p className="text-base text-gray-700">
              O sistema identifica o momento do acionamento e disponibiliza a
              gravação correspondente no site do Alertai Sports, onde os
              jogadores podem assistir e compartilhar os lances.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
